import * as apiClient from '../../services/api-client';

export const getAuthToken = async (store, authData) => {
    const auth = await apiClient.auth.getToken(authData);
    console.log('NEW AUTH TOKEN', auth);
    window.localStorage.setItem('cla_auth', JSON.stringify(auth));
    store.setState({ auth });
};